import React from "react";
import { Link } from "react-router-dom";
import { Clock3, Mail, ShieldCheck, Wrench } from "lucide-react";
import logo from "../assets/Navbar/logo.png";
import maintenanceGif from "../assets/Maintenence/Under-construction.gif";

function MaintenancePage() {
    return (
        <main className="min-h-screen bg-[#f6f7f9] px-4 py-6 text-[#111827] sm:px-6 lg:px-8">
            <div className="mx-auto flex min-h-[calc(100vh-48px)] w-full max-w-5xl flex-col">
                <header className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <div className="flex h-12 w-12 items-center justify-center rounded-md border border-[#ead6d6] bg-white shadow-sm">
                            <img src={logo} alt="Alik Store" className="h-9 w-9 object-contain" />
                        </div>
                        <div>
                            <p className="text-base font-bold text-[#BB002D]">Alik Store</p>
                            <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#6b7280]">Service update</p>
                        </div>
                    </div>

                    <div className="hidden items-center gap-2 rounded-md border border-[#e5e7eb] bg-white px-3 py-2 text-sm font-medium text-[#4b5563] shadow-sm sm:flex">
                        <ShieldCheck className="h-4 w-4 text-[#8B0000]" />
                        Secure checkout paused
                    </div>
                </header>

                <section className="flex flex-1 items-center justify-center py-12">
                    <div className="grid w-full items-stretch overflow-hidden rounded-lg border border-[#e5e7eb] bg-white shadow-[0_18px_55px_rgba(17,24,39,0.08)] lg:grid-cols-[1.05fr_0.95fr]">
                        <div className="flex flex-col justify-center px-6 py-10 sm:px-10 lg:px-12">
                            <div className="mb-6 flex h-14 w-14 items-center justify-center rounded-md bg-[#8B0000] text-white shadow-lg shadow-[#8B0000]/20">
                                <Wrench className="h-7 w-7" />
                            </div>

                            <p className="mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-[#8B0000]">
                                We will be right back
                            </p>

                            <h1 className="max-w-xl text-3xl font-bold leading-tight text-[#111827] sm:text-4xl">
                                Our store is getting a quick upgrade.
                            </h1>

                            <p className="mt-4 max-w-xl text-base leading-7 text-[#4B5563]">
                                We are improving the shopping experience and syncing a few systems behind the scenes. Please
                                check back shortly.
                            </p>

                            <div className="mt-8 grid gap-3 sm:grid-cols-2">
                                <div className="rounded-md border border-[#f0dddd] bg-[#fff8f8] p-4">
                                    <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#8B0000]">
                                        <Clock3 className="h-4 w-4" />
                                        Expected downtime
                                    </div>
                                    <p className="text-sm text-[#4B5563]">Short maintenance window</p>
                                </div>

                                <Link
                                    to="/contact"
                                    className="rounded-md border border-[#e5e7eb] bg-white p-4 transition hover:border-[#8B0000]/30 hover:bg-[#fffafa]"
                                >
                                    <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-[#111827]">
                                        <Mail className="h-4 w-4 text-[#8B0000]" />
                                        Need help?
                                    </div>
                                    <p className="text-sm text-[#4B5563]">Contact support</p>
                                </Link>
                            </div>
                        </div>

                        <div className="relative flex min-h-[300px] items-center justify-center overflow-hidden bg-[#fff4f4] p-10 text-[#111827] ">
                            <div className="absolute inset-0 bg-[linear-gradient(135deg,#fff8f8_0%,#fde8e8_52%,#f5f7f9_100%)]" />

                            <div className="relative flex w-full  items-center justify-center">
                                <img
                                    src={maintenanceGif}
                                    alt="Store maintenance in progress"
                                    className="w-full rounded-md object-fill"
                                />
                            </div>
                        </div>
                    </div>
                </section>

                <footer className="pb-2 text-center text-xs text-[#6b7280]">Thank you for your patience.</footer>
            </div>
        </main>
    );
}

export default MaintenancePage;
